import React, { useState, useEffect }  from 'react';
import styles from 'components/layout_and_quote_builder/_style.module.scss';
import PostRequest from 'components/common/PostRequest.jsx';
// import LayoutNavSectionCombinationImg from 'components/layout_and_quote_builder/LayoutNavSectionCombinationImg.jsx'
import LayoutSvg from 'components/layout_and_quote_builder/quote_builder/LayoutSvg.jsx'

const LayoutNavSectionCombination = ( { diecutting_result, count, layout_dimension, setTotalScore, index , setNumTotals, setNumOfDrawingsInSet} ) => {
  const name = `${diecutting_result.uuid}`;
  const [score, setScore] = useState( 0 )
  const [printingImageUrl, setPrintingImageUrl] = useState( '')
  const [diecuttingImageUrl, setDiecuttingImageUrl] = useState( '')
  const [numTotal, setNumTotal] = useState(0);
  const [numOfDrawingInSet, setNumOfDrawingInSet] = useState(1);

  const [partTypes, setPartTypes] = useState([])

  const getScore = () => {
    PostRequest({
      url: `/layouts-nav-section-combination-score`,
      data: {
        formula_options: window.dielineOptions,
        diecutting_result: diecutting_result,
        count: count,
        layout_dimension_id: layout_dimension.id
      },
      callback: (data) => {
        setScore( () => data.score )
        setNumTotal( () => data.diecutting_num_total )
        setNumOfDrawingInSet( () => data.num_of_drawings_in_set )
        setTotalScore( (prev) => prev + data.score )
        setPrintingImageUrl( () => data.printing_result_image_url )
        setDiecuttingImageUrl( () => data.diecutting_result_image_url  )

        setNumTotals((prev) => {
          return {
            ...prev,
            [index]: data.diecutting_num_total,
          };
        });

        setNumOfDrawingsInSet((prev) => {
          return {
            ...prev,
            [index]: data.num_of_drawings_in_set,
          };
        });

      }
    })
  }

  const printingCard = () => {
     return <table>
        <tbody>

          <tr>
            <th> Baski Yerlesimi </th>
          </tr>

          <tr>
            <td> <span className={styles.card_info}> {layout_dimension.description_en_mm} </span> </td>
          </tr>

          <tr>
            <td> <img className="additional_feature_img tag_img_white_bg" src={printingImageUrl} width="250" /> </td>
          </tr>

          <tr>
            <td> <span className={styles.card_info}> {diecutting_result.printing_result.layout_dimension.description_en_mm} </span> </td>
          </tr>

        </tbody>
      </table>
  }

  const diecuttingCard = () => {
     return <table>
        <tbody>
          <tr>
            <th> Bicak Yerlesimi</th>
          </tr>

          <tr>
            <td> <span className={styles.card_info}> {layout_dimension.description_en_mm} </span> </td>
          </tr>

          <tr>
            <td> <img className="additional_feature_img tag_img_white_bg" src={diecuttingImageUrl} width="250" /> </td>
          </tr>

          <tr>
            <td> <span className={styles.card_info}> {diecutting_result.layout_dimension.description_en_mm} </span> </td>
          </tr>

        </tbody>
      </table>
  }


  const card = () => {

    return <table className="table table-striped table-bordered">
      <tbody>

       {partTypes.length > 0 && (
        <tr>
          <th colSpan="2">
            {partTypes.join(", ")}, {diecutting_result.member.part_names.join(", ")}
          </th>
        </tr>
        )}

        <tr>
          <td className={styles.card_td}> { diecuttingCard() } </td>
          <td className={styles.card_td}> { printingCard() } </td>
        </tr>
      </tbody>
    </table>
  }

  // useEffect starts
  useEffect( getScore, [ diecutting_result, count] )
  useEffect( () =>  {
    for(let i=0; i < diecutting_result.member.part_types.length; i++) {
      let partType = diecutting_result.member.part_types[i];

      setPartTypes((prev) => {
        const newItem = t("quote_builder.part_type_" + partType);
        return Array.from(new Set([...prev, newItem]));
      });

    }
  }, [ diecutting_result, count] )

  // useEffect ends

  if(score == 0) { return <div key={name} data-score={score}> loading....</div> }

  return (
    <div className={styles.combinations_grid_item}
      key={name}
      data-score={score}
      data-numTotal={numTotal}
      data-numOfDrawingInSet={numOfDrawingInSet} >

      {card()}

    </div>
  )
}

export default LayoutNavSectionCombination;
